import * as constants from 'appConstants';
import { createAction } from 'appUtils';

export const triggerCSVImportDataLoad = () =>
  createAction(constants.LOAD_CSV_IMPORT_DATA.TRIGGER);
export const clearCSVImportData = () =>
  createAction(constants.CLEAR_CSV_IMPORT_DATA);
